import type { ArtistWorkHistory } from '@customTypes/types';
import { Accordion, Text } from '@mantine/core';
import { translate } from '@shared/i18n/translate';
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { PortfolioItemCard } from '@/features/artist/portfolio';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export const ExperienceSlider = ({ data }: { data: ArtistWorkHistory[] }) => {
  const sortedData = [...data].sort((a, b) => {
    if (a.untilNow && !b.untilNow) return -1;
    if (!a.untilNow && b.untilNow) return 1;

    const dateA = new Date(a.endDate || a.startDate).getTime();
    const dateB = new Date(b.endDate || b.startDate).getTime();
    return dateB - dateA;
  });

  return (
    <Accordion.Panel>
      {sortedData.length ? (
        <Swiper
          navigation
          className="experience-swiper"
          modules={[Navigation, Pagination]}
          pagination={{ clickable: true }}
          slidesPerView={1}
          spaceBetween={20}
        >
          {sortedData.map((item) => (
            <SwiperSlide key={item.clubName + item.startDate}>
              <PortfolioItemCard {...item} />
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <Text c="dimmed" fz={12}>
          {translate('commons.withouthExprience')}
        </Text>
      )}
    </Accordion.Panel>
  );
};
